export default __webpack_public_path__ + "static/media/discover.9f2009bc.svg";